import axios from 'axios';

import { API_URL, API_POSTFIX_V1, generateXHRErrorResponse } from '@services/api.service';

export const ChangePasswordApiService = {
  async changePassword({ token, password }) {
    try {
      return await axios.post(
        `${API_URL}${API_POSTFIX_V1}auth/password/change`,
        { token, password },
      );
    } catch (e) {
      return Promise.reject(generateXHRErrorResponse(e));
    }
  },
};
